import { createSlice } from "@reduxjs/toolkit";

// Lib
import Cookies from "js-cookie";
import { isDev } from "lib/helpers";

// Constants
import { amplitudeInstance, events } from "constans/cookie";

export type TCurrentPrice = {
  mg?: number;
  type?: string;
  label?: string;
  value?: string;
  price?: number | null;
};
export type countryItem = {
  name: string;
  region: string;
  fullName: string;
};
export type usaStateItem = {
  name: string;
  state: string;
};

// Interface
interface IState {
  user: {
    role?: string,
    user?: string,
    phone?: string,
    email?: string,
    title?: string,
    token?: string,
    country?: string,
    refresh?: string,
    lastName?: string,
    firstName?: string,
    authorized?: boolean,
    userId?: string | number,
    position?: string | number,
    organization?: string | null,
  },
  listImgs: [],
  loadingLogout: boolean,
  loadingListImgs: boolean,
  currentPrice: TCurrentPrice;
  typePrice?: string;
  isCloseSmallDropdown?: boolean,

  showFull: boolean,
  showSmall: boolean,
  activeRequests: any,
  requestsLog: any,

  countries: countryItem[] | [],
  loadingCountries: boolean,

  usaStates: usaStateItem[] | [],
  loadingUsaStates: boolean,

  paymentsToken: string,
  loadingPaymentsToken: boolean,
}

const initialCurrentPrice = {
  type: "Usd",
  label: "5mg",
  mg: 5,
  value: "price5mg",
  price: null
};

const keyPriceApp = "priceApp";
const currentPrice = JSON.parse(localStorage.getItem(keyPriceApp) || JSON.stringify(initialCurrentPrice));

const initialState: IState = {
  user: {
    role: "",
    user: "",
    email: "",
    phone: "",
    title: "",
    token: "",
    country: "",
    refresh: "",
    userId: "",
    position: "",
    lastName: "",
    firstName: "",
    organization: "",
    authorized: false
  },
  listImgs: [],
  typePrice: "EBC",
  loadingLogout: false,
  loadingListImgs: false,
  currentPrice: currentPrice,
  isCloseSmallDropdown: false,

  showFull: false,
  showSmall: false,
  activeRequests: [],
  requestsLog: {
    // 'requestUniqueId': requestLogItem
  },

  countries: [],
  loadingCountries: false,

  usaStates: [],
  loadingUsaStates: false,

  paymentsToken: '',
  loadingPaymentsToken: false,
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState: initialState,
  reducers: {
    getPaymentsToken: (state, action) => {
      state.loadingPaymentsToken = true;
    },
    getPaymentsTokenError: (state) => {
      state.loadingPaymentsToken = false;
    },
    getPaymentsTokenSuccess: (state, action) => {
      state.loadingPaymentsToken = false;
      state.paymentsToken = action.payload;
    },

    getUsaStates: (state) => {
      state.loadingUsaStates = true;
    },
    getUsaStatesError: (state) => {
      state.loadingUsaStates = false;
    },
    getUsaStatesSuccess: (state, action) => {
      state.loadingUsaStates = false;
      state.usaStates = action.payload;
    },

    getAddressesCountries: (state) => {
      state.loadingCountries = true;
    },
    getAddressesCountriesError: (state) => {
      state.loadingCountries = false;
    },
    getAddressesCountriesSuccess: (state, action) => {
      state.loadingCountries = false;
      state.countries = action.payload;
    },

    handlerChangeTypePrice: (state, action) => {
      state.typePrice = action.payload;
    },

    apiResponse: (state, action) => {
      const activeRequests = action.payload.id
        ? state.activeRequests.filter((id: any) => id !== action.payload.id)
        : [...state.activeRequests];

      const requestsLogNew = { ...state.requestsLog };
      if (action.payload.id) {
        requestsLogNew[action.payload.id] = {
          ...requestsLogNew[action.payload.id],
          end: new Date().toISOString(),
        };
      }

      return {
        ...state,
        activeRequests: activeRequests,
        requestsLog: requestsLogNew
      };
    },

    apiRequest: (state, action) => {
      let requestsLog = {};
      if (isDev) {
        requestsLog = action.payload.id
          ? {
            ...state.requestsLog,
            [action.payload.id]: {
              id: action.payload.id,
              url: action.payload.url,
              start: new Date().toISOString(),
            }
          }
          : { ...state.activeRequests };
      }

      return {
        ...state,
        activeRequests: [...state.activeRequests, action.payload.id],
        requestsLog: requestsLog
      };
    },


    getListImg: (state, action) => {
      state.loadingListImgs = true;
    },
    getListImgError: (state) => {
      state.loadingListImgs = false;
    },
    getListImgSuccess: (state, action) => {
      state.listImgs = action.payload;
      state.loadingListImgs = false;
    },

    toggleModal: (state, action) => {
      state.isCloseSmallDropdown = action.payload;
    },

    checkAuth: (state) => {
    },
    checkAuthSuccess: (state, action) => {
      state.user = {
        ...state.user,
        ...action.payload?.data,
        authorized: true
      };
    },

    changeAuthorized: (state, action) => {
      state.user.authorized = action.payload;
    },

    updateSettingsUser: (state, action) => {
      return {
        ...state,
        user: {
          ...state.user,
          ...action.payload
        }
      };
    },

    logout: (state) => {
      state.loadingLogout = true;
    },
    logoutError: (state) => {
      state.loadingLogout = false;
    },
    logoutSuccess: (state) => {
      localStorage.removeItem("auth");

      state.user = initialState.user;

      const formData = {
        data: "",
        type: "SIGN_OUT"
      };

      localStorage.setItem("synchronizationTab", JSON.stringify(formData));

      const isCookie = Cookies.get("cookieName");
      if (isCookie) {
        amplitudeInstance.logEvent(events.logout);
      }
    },
    updateLogout: (state) => {
      localStorage.removeItem("auth");

      state.user = initialState.user;
    },

    handlerChangePriceApp: (state, action) => {
      const selected = action.payload;
      state.currentPrice = selected;

      localStorage.setItem(keyPriceApp, JSON.stringify(selected));
    }
  }
});

export const {
  getPaymentsToken,
  getPaymentsTokenError,
  getPaymentsTokenSuccess,

  getUsaStates,
  getUsaStatesError,
  getUsaStatesSuccess,

  getAddressesCountries,
  getAddressesCountriesError,
  getAddressesCountriesSuccess,

  handlerChangeTypePrice,

  apiRequest,
  apiResponse,

  logout,
  checkAuth,
  getListImg,
  toggleModal,
  logoutError,
  updateLogout,
  logoutSuccess,
  getListImgError,
  checkAuthSuccess,
  changeAuthorized,
  getListImgSuccess,
  updateSettingsUser,
  handlerChangePriceApp
} = settingsSlice.actions;

export default settingsSlice.reducer;
